var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgA3Printer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 608.51 925.39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 347.164,
    y1: 539.785,
    x2: 347.164,
    y2: 445.725,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#545a5c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#707880"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 364.73,
    y1: 312.299,
    x2: 364.73,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c7b299"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e5d8c1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Machnes_and_dividers"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 139.317,
    y: 572.371,
    width: 447.953,
    height: 347.478,
    rx: 14.682,
    ry: 14.682,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145.936,
    y: 576.99,
    width: 447.953,
    height: 347.478,
    rx: 14.682,
    ry: 14.682,
    fill: "#e8b185"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 169.173,
    y: 592.13,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.173,
    y: 592.129,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(786.417 434.978) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 224.659,
    y: 592.13,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224.658,
    y: 592.129,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(841.901 379.493) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 280.144,
    y: 592.13,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280.143,
    y: 592.129,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(897.385 324.008) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 335.629,
    y: 592.13,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335.629,
    y: 592.129,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(952.869 268.522) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 391.115,
    y: 592.13,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.114,
    y: 592.129,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(1008.353 213.037) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 446.6,
    y: 592.13,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 446.6,
    y: 592.129,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(1063.837 157.551) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 502.086,
    y: 592.13,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 502.085,
    y: 592.129,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(1119.321 102.066) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 557.571,
    y: 592.13,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 557.57,
    y: 592.129,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(1174.805 46.581) rotate(89.999)",
    fill: "#aa7552"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 169.173,
    y: 648.138,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.173,
    y: 648.137,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(842.426 490.986) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 224.659,
    y: 648.138,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224.658,
    y: 648.137,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(897.91 435.5) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 280.144,
    y: 648.138,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280.143,
    y: 648.137,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(953.394 380.015) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 335.629,
    y: 648.138,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335.629,
    y: 648.137,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(1008.878 324.529) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 391.115,
    y: 648.138,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.114,
    y: 648.137,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(1064.362 269.044) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 446.6,
    y: 648.138,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 446.6,
    y: 648.137,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(1119.846 213.559) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 502.086,
    y: 648.138,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 502.085,
    y: 648.137,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(1175.33 158.073) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 557.571,
    y: 648.138,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 557.57,
    y: 648.137,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(1230.814 102.588) rotate(89.999)",
    fill: "#aa7552"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 169.173,
    y: 704.147,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.173,
    y: 704.146,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(898.434 546.993) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 224.659,
    y: 704.147,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224.658,
    y: 704.146,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(953.918 491.508) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 280.144,
    y: 704.147,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280.143,
    y: 704.146,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(1009.402 436.022) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 335.629,
    y: 704.147,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335.629,
    y: 704.146,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(1064.886 380.537) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 391.115,
    y: 704.147,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.114,
    y: 704.146,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(1120.37 325.051) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 446.6,
    y: 704.147,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 446.6,
    y: 704.146,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(1175.854 269.566) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 502.086,
    y: 704.147,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 502.085,
    y: 704.146,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(1231.338 214.081) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 557.571,
    y: 704.147,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 557.57,
    y: 704.146,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(1286.823 158.595) rotate(89.999)",
    fill: "#aa7552"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 169.173,
    y: 760.156,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.173,
    y: 760.155,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(954.443 603) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 224.659,
    y: 760.156,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224.658,
    y: 760.155,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(1009.927 547.515) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 280.144,
    y: 760.156,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280.143,
    y: 760.155,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(1065.411 492.029) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 335.629,
    y: 760.156,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335.629,
    y: 760.155,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(1120.895 436.544) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 391.115,
    y: 760.156,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.114,
    y: 760.155,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(1176.379 381.059) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 446.6,
    y: 760.156,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 446.6,
    y: 760.155,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(1231.863 325.573) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 502.086,
    y: 760.156,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 502.085,
    y: 760.155,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(1287.347 270.088) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 557.571,
    y: 760.156,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 557.57,
    y: 760.155,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(1342.831 214.603) rotate(89.999)",
    fill: "#aa7552"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 169.173,
    y: 816.164,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.173,
    y: 816.164,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(1010.452 659.008) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 224.659,
    y: 816.164,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224.658,
    y: 816.164,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(1065.936 603.522) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 280.144,
    y: 816.164,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280.143,
    y: 816.164,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(1121.42 548.037) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 335.629,
    y: 816.164,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335.629,
    y: 816.164,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(1176.904 492.551) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 391.115,
    y: 816.164,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.114,
    y: 816.164,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(1232.388 437.066) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 446.6,
    y: 816.164,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 446.6,
    y: 816.164,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(1287.872 381.581) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 502.086,
    y: 816.164,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 502.085,
    y: 816.164,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(1343.356 326.095) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 557.571,
    y: 816.164,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 557.57,
    y: 816.164,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(1398.84 270.61) rotate(89.999)",
    fill: "#aa7552"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 169.173,
    y: 872.173,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.173,
    y: 872.172,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(1066.46 715.015) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 224.659,
    y: 872.173,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224.658,
    y: 872.172,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(1121.944 659.529) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 280.144,
    y: 872.173,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280.143,
    y: 872.172,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(1177.428 604.044) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 335.629,
    y: 872.173,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335.629,
    y: 872.172,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(1232.912 548.559) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 391.115,
    y: 872.173,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.114,
    y: 872.172,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(1288.396 493.073) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 446.6,
    y: 872.173,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 446.6,
    y: 872.172,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(1343.881 437.588) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 502.086,
    y: 872.173,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 502.085,
    y: 872.172,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(1399.365 382.103) rotate(89.999)",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 557.571,
    y: 872.173,
    width: 13.083,
    height: 37.155,
    rx: 6.541,
    ry: 6.541,
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 557.57,
    y: 872.172,
    width: 13.083,
    height: 37.157,
    rx: 6.541,
    ry: 6.541,
    transform: "translate(1454.849 326.617) rotate(89.999)",
    fill: "#aa7552"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "581.74 560.3 145.79 560.3 51.44 516.46 421.77 516.46 581.74 560.3",
    fill: "#e8b185"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145.79,
    y: 560.3,
    width: 435.95,
    height: 10.69,
    fill: "#f2c2a0"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "145.79 560.3 145.79 570.99 51.44 525.54 51.44 516.46 145.79 560.3",
    fill: "#aa7552"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M350.435,608.517v4.99c0,1.04-.16,2.05-.46,2.99-1.27,4.06-5.05,7.01-9.54,7.01h-107.515c-4.49,0-8.27-2.95-9.54-7.01-.3-.94-.46-1.95-.46-2.99v-4.99h127.515Z",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 222.916,
    y: 601.71,
    width: 16.409,
    height: 16.752,
    rx: 8.204,
    ry: 8.204,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 334.031,
    y: 601.71,
    width: 16.409,
    height: 16.752,
    rx: 8.204,
    ry: 8.204,
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.975,616.497c-1.27,4.06-5.05,7.01-9.54,7.01h-107.515c-4.49,0-8.27-2.95-9.54-7.01h126.595Z",
    fill: "#b0b0b0"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M515.704,608.517v4.99c0,1.04-.16,2.05-.46,2.99-1.27,4.06-5.05,7.01-9.54,7.01h-107.515c-4.49,0-8.27-2.95-9.54-7.01-.3-.94-.46-1.95-.46-2.99v-4.99h127.515Z",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 388.185,
    y: 601.71,
    width: 16.409,
    height: 16.752,
    rx: 8.204,
    ry: 8.204,
    fill: "#666"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 499.3,
    y: 601.71,
    width: 16.409,
    height: 16.752,
    rx: 8.204,
    ry: 8.204,
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.244,616.497c-1.27,4.06-5.05,7.01-9.54,7.01h-107.515c-4.49,0-8.27-2.95-9.54-7.01h126.595Z",
    fill: "#333"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "198.016 460.146 198.016 547.446 108.046 511.226 108.046 436.076 198.016 460.146",
    fill: "#14161c"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "179.71 451.08 182.572 539.532 89.74 502.16 89.74 427.01 179.71 451.08",
    fill: "#5a5f62"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "512.65 447.93 475.48 448.28 212.9 450.77 179.71 451.08 87.95 426.53 389.23 426.53 512.65 447.93",
    fill: "#2b3033"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "220.56 445.87 212.9 450.77 179.71 451.08 87.95 426.53 154.28 426.53 220.56 445.87",
    fill: "#777"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "512.65 447.93 475.48 448.28 473.58 446.92 365.05 426.53 389.23 426.53 512.65 447.93",
    fill: "#777"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M503.065,539.785c-1.48,4.94-6.08,8.56-11.49,8.56H202.506c-5.41,0-10.01-3.62-11.49-8.56H503.065Z",
    fill: "#14161c"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M518.614,457.075v72.71c0,5.52-4.48,10-10,10H185.714c-5.52,0-10-4.48-10-10v-74.06c0-5.54,4.5-10.02,10.04-10l22.76,.1,11.15,.05h1.01l253.02,1.05h1l11.12,.05,22.84,.1c5.51,.02,9.96,4.49,9.96,10Z",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181.659,
    y: 451.391,
    width: 18.535,
    height: 12.119,
    rx: 6.059,
    ry: 6.059,
    fill: "#191c1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.035,473.421c-4.679,0-8.485-3.807-8.485-8.485s3.806-8.485,8.485-8.485,8.485,3.806,8.485,8.485-3.806,8.485-8.485,8.485Z",
    fill: "#191c1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.525,464.935c0,3.85-2.93,7.04-6.68,7.44-.26,.04-.54,.05-.81,.05-.25,0-.51-.01-.75-.04-.5-.05-.98-.15-1.44-.29-1.26-.38-2.37-1.09-3.24-2.02-1.28-1.33-2.06-3.14-2.06-5.14,0-3.35,2.21-6.19,5.26-7.13,.7-.23,1.45-.35,2.23-.35,.54,0,1.06,.06,1.57,.17,.48,.1,.95,.25,1.4,.45,.48,.2,.94,.46,1.36,.77,1.91,1.34,3.16,3.57,3.16,6.09Z",
    fill: "#a1afb2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.035,496.098c-4.679,0-8.485-3.807-8.485-8.485s3.806-8.485,8.485-8.485,8.485,3.807,8.485,8.485-3.806,8.485-8.485,8.485Z",
    fill: "#191c1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.525,487.615c0,3.93-3.04,7.15-6.9,7.45-.19,.02-.39,.03-.59,.03-.33,0-.65-.02-.96-.07-.5-.06-.98-.17-1.44-.33-1.25-.42-2.35-1.16-3.2-2.13-1.18-1.32-1.89-3.05-1.89-4.95,0-3.27,2.09-6.04,5.01-7.06,.78-.28,1.61-.43,2.48-.43,.46,0,.92,.04,1.36,.13,.49,.08,.96,.22,1.41,.41,.49,.19,.95,.43,1.38,.72,2.01,1.34,3.34,3.63,3.34,6.23Z",
    fill: "#a1afb2"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 238.867,
    y1: 467.787,
    x2: 238.867,
    y2: 535.867,
    fill: "none",
    stroke: "#bcbcbc",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 455.223,
    y1: 467.787,
    x2: 455.223,
    y2: 535.867,
    fill: "none",
    stroke: "#bcbcbc",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    d: "M473.576,446.925v8.86c0,6.6-5.4,12-12,12H232.506c-6.6,0-12-5.4-12-12v-8.79c0-.38,.02-.75,.05-1.12l253.02,1.05Z",
    fill: "#191c1e"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M497.395,480.255l-3.76,14.44c-1.25-.42-2.35-1.16-3.2-2.13l3.12-12.01c.78-.28,1.61-.43,2.48-.43,.46,0,.92,.04,1.36,.13Z",
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.185,481.385l-3.56,13.68c-.19,.02-.39,.03-.59,.03-.33,0-.65-.02-.96-.07l3.73-14.36c.49,.19,.95,.43,1.38,.72Z",
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.605,457.625l-3.76,14.47c-1.26-.38-2.37-1.09-3.24-2.02l3.2-12.27c.7-.23,1.45-.35,2.23-.35,.54,0,1.06,.06,1.57,.17Z",
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.365,458.845l-3.52,13.53c-.26,.04-.54,.05-.81,.05-.25,0-.51-.01-.75-.04l3.72-14.31c.48,.2,.94,.46,1.36,.77Z",
    fill: "#fff",
    opacity: 0.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M333.292,486.972c-1.508,.871-2.995,1.73-4.476,2.586-.048-.026-.029-.053-.016-.076,.025-.045,.053-.088,.08-.132,.712-1.139,1.425-2.278,2.136-3.418,.042-.067,.1-.128,.108-.212-1.467-1.016-4.155-1.111-5.897,.863-1.649,1.869-1.511,4.715,.314,6.421,.654,.611,1.424,1.002,2.306,1.167,.881,.164,1.74,.081,2.571-.251,.831-.332,1.504-.872,2.052-1.612,.09,.222,.127,.428,.185,.64-.07,.083-.137,.17-.211,.25-.472,.514-1.029,.917-1.647,1.237-.809,.419-1.667,.683-2.567,.822-.422,.065-.846,.095-1.271,.11-.47,.017-.939-.024-1.405-.085-.657-.087-1.297-.243-1.917-.48-.774-.297-1.493-.691-2.107-1.254-.917-.841-1.508-1.869-1.712-3.103-.17-1.028-.029-2.019,.413-2.964,.556-1.189,1.438-2.061,2.602-2.654,.804-.41,1.655-.675,2.546-.815,.626-.098,1.255-.14,1.887-.112,1.16,.052,2.288,.261,3.349,.755,1.047,.487,1.913,1.194,2.571,2.148,.033,.047,.06,.098,.104,.171Z",
    fill: "#efefef"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.514,495.061c-.233,.03-3.123,.026-3.312-.004-.006-.037-.016-.078-.018-.12-.003-.073-.002-.147-.002-.22,0-2.027,0-4.053,0-6.08,0-.125,0-.25-.015-.374-.047-.396-.374-.701-.762-.731-.472-.037-.816,.295-.887,.634-.022,.107-.032,.218-.032,.327-.003,.646-.001,1.292-.001,1.938,0,1.454,0,2.908,0,4.362,0,.087-.004,.173-.006,.245-.021,.019-.025,.025-.032,.029-.006,.003-.014,.006-.021,.006-1.028,.003-2.055,.005-3.083,.008-.044,0-.088-.002-.132-.006-.014-.001-.026-.011-.052-.022-.005-.043-.015-.092-.016-.141-.002-.191,0-.382,0-.573,0-2.166,0-4.332,0-6.498,0-.094-.004-.188-.006-.283-.089-.043-.171-.028-.25-.029-.565-.001-1.13,0-1.696,0h-.232c.012-.079,.079-.086,.123-.107,.544-.256,1.09-.509,1.635-.763,.459-.214,.918-.427,1.376-.642,.23-.108,.47-.156,.725-.159,.692-.01,1.36,.452,1.583,1.148,.024,.075,.049,.149,.079,.238,.08-.034,.147-.06,.211-.09,.805-.374,1.61-.747,2.414-1.124,.258-.121,.524-.179,.809-.17,.71,.024,1.333,.5,1.536,1.181,.061,.206,.078,.417,.078,.631,0,2.21,0,4.42,0,6.63,0,.206,0,.411,0,.617,0,.043-.008,.086-.013,.141Z",
    fill: "#efefef"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.57,495.061c-.229,.028-3.129,.027-3.318,.001-.007-.038-.019-.08-.021-.122-.004-.081-.001-.161-.001-.242,0-2.041,0-4.083,0-6.124,0-.073,0-.147-.001-.22-.007-.49-.427-.822-.834-.826-.367-.003-.817,.271-.853,.81-.005,.08-.002,.161-.002,.242,0,2.071,0,4.141,0,6.212,0,.087-.004,.173-.007,.264-.089,.036-.17,.025-.248,.025-.947,0-1.894,0-2.841,0-.072,0-.144-.005-.226-.008-.008-.052-.018-.094-.02-.135-.003-.073-.001-.147-.001-.22,0-2.298,0-4.597,0-6.895,0-.087-.004-.174-.006-.262-.086-.047-.168-.031-.246-.031-.565-.002-1.131,0-1.696,0-.073,0-.147,0-.219,0-.024-.073,.036-.073,.069-.088,.744-.348,1.489-.695,2.233-1.043,.279-.13,.555-.269,.838-.389,.584-.248,1.147-.203,1.672,.163,.298,.208,.502,.49,.614,.837,.022,.069,.043,.139,.063,.202,.063,.042,.106,.002,.15-.019,.652-.303,1.303-.607,1.955-.911,.199-.093,.395-.195,.599-.277,.649-.261,1.252-.183,1.789,.276,.332,.284,.515,.654,.556,1.09,.009,.095,.012,.191,.012,.286,0,2.386,0,4.773,0,7.159,0,.079-.006,.159-.009,.248Z",
    fill: "#efefef"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.947,495.057c-.213,.033-3.138,.032-3.332,0-.019-.063-.042-.132-.06-.201-.103-.382-.205-.765-.308-1.148-.015-.055-.037-.109-.056-.165-.088,.027-.117,.101-.162,.155-.626,.753-1.41,1.257-2.365,1.477-1.089,.251-2.129,.116-3.103-.446-.386-.222-.715-.513-.981-.871-.728-.981-.71-2.247,.048-3.206,.437-.552,1.002-.921,1.664-1.143,.929-.312,1.859-.311,2.784,.023,.375,.136,.719,.33,1.039,.569,.051,.038,.104,.073,.182,.127-.008-.065-.008-.101-.017-.134-.227-.849-.449-1.699-.685-2.551-.238-.031-.465-.011-.691-.014-.227-.004-.455,0-.683,0h-.705c-.228,0-.455,0-.683,0-.228,0-.455,0-.683,0-.227,0-.455,0-.682,0-.012-.075,.046-.069,.081-.081,.875-.32,1.75-.639,2.625-.958,.434-.158,.865-.326,1.303-.471,1.044-.346,1.985-.153,2.799,.588,.359,.327,.603,.737,.734,1.208,.145,.523,.286,1.048,.426,1.572,.483,1.8,.965,3.6,1.447,5.4,.023,.084,.041,.17,.065,.272Zm-7.554-2.769c-.026,.801,.63,1.679,1.679,1.679,.991,0,1.686-.794,1.683-1.679-.003-1.002-.832-1.682-1.683-1.68-.941,.002-1.698,.788-1.679,1.681Z",
    fill: "#efefef"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.692,495.369c-2.706-.038-4.754-2.165-4.754-4.754,0-2.752,2.244-4.759,4.741-4.76,2.589-.001,4.746,2.098,4.754,4.746,.008,2.472-1.937,4.718-4.741,4.768Zm-.808-8.85c-.719-.011-1.202,.679-1.037,1.295,.013,.05,.023,.1,.037,.15,.522,1.948,1.044,3.895,1.566,5.843,.025,.092,.052,.184,.089,.271,.145,.334,.482,.627,.981,.624,.431-.002,.815-.283,.966-.681,.092-.244,.077-.485,.01-.733-.5-1.855-.996-3.711-1.493-5.566-.046-.17-.085-.342-.143-.508-.148-.419-.535-.69-.975-.694Z",
    fill: "#efefef"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "112.43 1.62 112.43 925.39 0 803.43 0 52.64 112.43 1.62",
    fill: "#aa7552"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.931,
    y: 1.62,
    width: 15.499,
    height: 923.77,
    fill: "#e8b185"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M6.035,105.979h0c-.75,.25-1.356-.318-1.356-1.27v-35.361c0-.951,.606-1.975,1.356-2.288h0c.752-.314,1.364,.207,1.364,1.163v35.567c0,.957-.612,1.937-1.364,2.188Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.204,91.342v-6.767c0-1.884,1.196-3.879,2.679-4.458l2.308-.901c1.508-.589,2.737,.485,2.737,2.401v6.88c0,1.916-1.229,3.913-2.737,4.457l-2.308,.833c-1.484,.536-2.679-.561-2.679-2.445Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M17.86,102.029h0c-.788,.263-1.425-.315-1.425-1.29v-36.253c0-.975,.637-2.032,1.425-2.36h0c.791-.33,1.434,.197,1.434,1.178v36.47c0,.981-.643,1.991-1.434,2.255Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.834,87.058v-6.937c0-1.932,1.256-3.988,2.816-4.597l2.426-.947c1.586-.619,2.879,.469,2.879,2.434v7.055c0,1.965-1.293,4.024-2.878,4.596l-2.426,.876c-1.559,.563-2.816-.55-2.816-2.481Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M30.3,97.875h0c-.83,.277-1.5-.31-1.5-1.311V59.374c0-1,.67-2.091,1.5-2.437h0c.832-.347,1.509,.186,1.509,1.193v37.419c0,1.007-.677,2.049-1.509,2.327Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.063,82.555v-7.115c0-1.981,1.322-4.104,2.963-4.744l2.553-.997c1.669-.651,3.031,.452,3.031,2.468v7.24c0,2.016-1.361,4.142-3.031,4.744l-2.553,.922c-1.641,.592-2.963-.537-2.963-2.518Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M43.402,93.499h0c-.874,.292-1.581-.305-1.581-1.332V53.989c0-1.027,.707-2.154,1.581-2.519h0c.877-.366,1.591,.174,1.591,1.208v38.42c0,1.034-.714,2.11-1.591,2.403Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.938,77.813v-7.303c0-2.034,1.393-4.226,3.122-4.901l2.691-1.05c1.76-.687,3.195,.431,3.195,2.502v7.435c0,2.07-1.435,4.267-3.195,4.902l-2.691,.971c-1.729,.624-3.122-.522-3.122-2.556Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M57.222,88.884h0c-.923,.308-1.669-.298-1.669-1.353V48.31c0-1.055,.746-2.222,1.669-2.607h0c.926-.386,1.679,.16,1.679,1.222v39.475c0,1.062-.753,2.174-1.679,2.484Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.511,72.814v-7.502c0-2.089,1.47-4.356,3.294-5.068l2.841-1.109c1.858-.725,3.374,.408,3.374,2.536v7.64c0,2.128-1.516,4.399-3.374,5.07l-2.841,1.025c-1.825,.659-3.295-.504-3.295-2.593Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M71.82,84.009h0c-.975,.326-1.764-.29-1.764-1.375V42.313c0-1.085,.788-2.293,1.764-2.7h0c.979-.408,1.775,.144,1.775,1.236v40.59c0,1.092-.796,2.243-1.775,2.57Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.841,67.536v-7.711c0-2.147,1.553-4.494,3.481-5.246l3.003-1.172c1.965-.767,3.568,.381,3.568,2.569v7.857c0,2.188-1.603,4.54-3.568,5.25l-3.003,1.084c-1.928,.696-3.481-.484-3.481-2.631Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M87.264,78.852h0c-1.033,.345-1.867-.281-1.867-1.397V35.969c0-1.116,.834-2.369,1.867-2.8h0c1.037-.433,1.88,.127,1.88,1.25v41.77c0,1.124-.843,2.316-1.88,2.662Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.994,61.956v-7.932c0-2.209,1.643-4.641,3.685-5.437l3.179-1.241c2.081-.812,3.779,.351,3.779,2.603v8.087c0,2.252-1.698,4.691-3.779,5.442l-3.179,1.148c-2.041,.737-3.685-.461-3.685-2.669Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M103.629,73.386h0c-1.095,.366-1.98-.27-1.98-1.42V29.248c0-1.149,.885-2.45,1.98-2.907h0c1.099-.459,1.994,.106,1.994,1.264v43.02c0,1.157-.894,2.394-1.994,2.761Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.041,56.046v-8.166c0-2.274,1.742-4.797,3.906-5.642l3.372-1.316c2.207-.861,4.009,.316,4.009,2.636v8.331c0,2.32-1.802,4.851-4.009,5.648l-3.372,1.217c-2.164,.781-3.906-.433-3.906-2.708Z",
    fill: "#7f5640"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M6.035,164.645h0c-.75,.156-1.356-.489-1.356-1.44v-35.361c0-.951,.606-1.899,1.356-2.118h0c.752-.219,1.364,.378,1.364,1.335v35.567c0,.957-.612,1.86-1.364,2.017Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.204,149.528v-6.767c0-1.884,1.196-3.729,2.679-4.121l2.308-.611c1.508-.399,2.737,.828,2.737,2.744v6.88c0,1.916-1.229,3.758-2.737,4.113l-2.308,.543c-1.484,.349-2.679-.897-2.679-2.781Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M17.86,162.181h0c-.788,.164-1.425-.494-1.425-1.469v-36.253c0-.975,.637-1.952,1.425-2.182h0c.791-.231,1.434,.377,1.434,1.358v36.47c0,.981-.643,1.91-1.434,2.075Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.834,146.704v-6.937c0-1.932,1.256-3.83,2.816-4.243l2.426-.642c1.586-.42,2.879,.831,2.879,2.795v7.055c0,1.965-1.293,3.862-2.878,4.235l-2.426,.571c-1.559,.367-2.816-.903-2.816-2.835Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M30.3,159.588h0c-.83,.173-1.5-.498-1.5-1.499v-37.191c0-1,.67-2.007,1.5-2.249h0c.832-.243,1.509,.376,1.509,1.382v37.419c0,1.007-.677,1.964-1.509,2.137Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.063,143.736v-7.115c0-1.981,1.322-3.938,2.963-4.372l2.553-.676c1.669-.442,3.031,.832,3.031,2.848v7.24c0,2.016-1.361,3.971-3.031,4.364l-2.553,.601c-1.641,.386-2.963-.909-2.963-2.89Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M43.402,156.857h0c-.874,.182-1.581-.503-1.581-1.53v-38.179c0-1.027,.707-2.066,1.581-2.321h0c.877-.256,1.591,.374,1.591,1.407v38.42c0,1.034-.714,2.02-1.591,2.203Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.938,140.61v-7.303c0-2.034,1.393-4.051,3.122-4.509l2.691-.713c1.76-.466,3.195,.832,3.195,2.903v7.435c0,2.07-1.435,4.087-3.195,4.501l-2.691,.634c-1.729,.407-3.122-.914-3.122-2.947Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M57.222,153.976h0c-.923,.192-1.669-.508-1.669-1.563v-39.221c0-1.055,.746-2.128,1.669-2.397h0c.926-.27,1.679,.371,1.679,1.433v39.475c0,1.062-.753,2.08-1.679,2.273Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.511,137.315v-7.502c0-2.089,1.47-4.171,3.294-4.654l2.841-.752c1.858-.492,3.374,.832,3.374,2.959v7.64c0,2.128-1.516,4.209-3.374,4.647l-2.841,.669c-1.825,.43-3.295-.918-3.295-3.007Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M71.82,150.934h0c-.975,.203-1.764-.512-1.764-1.596v-40.322c0-1.085,.788-2.194,1.764-2.478h0c.979-.286,1.775,.367,1.775,1.459v40.59c0,1.092-.796,2.143-1.775,2.347Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.841,133.836v-7.711c0-2.147,1.553-4.299,3.481-4.809l3.003-.795c1.965-.52,3.568,.829,3.568,3.017v7.858c0,2.188-1.603,4.339-3.568,4.802l-3.003,.707c-1.928,.454-3.481-.921-3.481-3.068Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M87.264,147.715h0c-1.033,.215-1.867-.516-1.867-1.632v-41.486c0-1.116,.834-2.264,1.867-2.565h0c1.037-.302,1.88,.363,1.88,1.486v41.77c0,1.124-.843,2.21-1.88,2.426Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.994,130.157v-7.932c0-2.209,1.643-4.434,3.685-4.975l3.179-.842c2.081-.551,3.779,.825,3.779,3.077v8.087c0,2.252-1.698,4.477-3.779,4.967l-3.179,.749c-2.041,.481-3.685-.923-3.685-3.132Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M103.629,144.304h0c-1.095,.228-1.98-.519-1.98-1.668v-42.719c0-1.149,.885-2.339,1.98-2.658h0c1.099-.321,1.994,.357,1.994,1.514v43.02c0,1.157-.894,2.282-1.994,2.511Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.041,126.262v-8.166c0-2.274,1.742-4.579,3.906-5.152l3.372-.893c2.207-.584,4.009,.819,4.009,3.139v8.331c0,2.32-1.802,4.625-4.009,5.144l-3.372,.794c-2.164,.51-3.906-.924-3.906-3.198Z",
    fill: "#7f5640"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M6.035,223.312h0c-.75,.062-1.356-.659-1.356-1.61v-35.361c0-.951,.606-1.823,1.356-1.948h0c.752-.125,1.364,.549,1.364,1.506v35.567c0,.957-.612,1.783-1.364,1.845Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.204,207.714v-6.767c0-1.884,1.196-3.578,2.679-3.785l2.308-.321c1.508-.21,2.737,1.172,2.737,3.088v6.88c0,1.916-1.229,3.604-2.737,3.77l-2.308,.254c-1.484,.163-2.679-1.233-2.679-3.118Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M17.86,222.332h0c-.788,.065-1.425-.672-1.425-1.648v-36.253c0-.975,.637-1.872,1.425-2.003h0c.791-.131,1.434,.557,1.434,1.538v36.47c0,.981-.643,1.83-1.434,1.895Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.834,206.35v-6.937c0-1.932,1.256-3.673,2.816-3.89l2.426-.338c1.586-.221,2.879,1.192,2.879,3.157v7.055c0,1.965-1.293,3.699-2.878,3.874l-2.426,.267c-1.559,.171-2.816-1.256-2.816-3.188Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M30.3,221.301h0c-.83,.069-1.5-.687-1.5-1.687v-37.191c0-1,.67-1.923,1.5-2.061h0c.832-.138,1.509,.565,1.509,1.572v37.419c0,1.007-.677,1.879-1.509,1.948Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.063,204.917v-7.115c0-1.981,1.322-3.772,2.963-4l2.553-.356c1.669-.232,3.031,1.212,3.031,3.229v7.24c0,2.016-1.361,3.8-3.031,3.984l-2.553,.281c-1.641,.18-2.963-1.281-2.963-3.262Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M43.402,220.214h0c-.874,.072-1.581-.702-1.581-1.729v-38.179c0-1.027,.707-1.977,1.581-2.122h0c.877-.146,1.591,.573,1.591,1.607v38.42c0,1.034-.714,1.931-1.591,2.003Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.938,203.407v-7.303c0-2.034,1.393-3.876,3.122-4.117l2.691-.375c1.76-.245,3.195,1.234,3.195,3.304v7.435c0,2.07-1.435,3.906-3.195,4.1l-2.691,.296c-1.729,.19-3.122-1.306-3.122-3.339Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M57.222,219.068h0c-.923,.077-1.669-.717-1.669-1.772v-39.221c0-1.055,.746-2.034,1.669-2.188h0c.926-.154,1.679,.582,1.679,1.644v39.475c0,1.062-.753,1.985-1.679,2.062Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.511,201.816v-7.502c0-2.089,1.47-3.987,3.294-4.241l2.841-.396c1.858-.259,3.374,1.255,3.374,3.383v7.64c0,2.128-1.516,4.019-3.374,4.223l-2.841,.312c-1.825,.201-3.295-1.331-3.295-3.42Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M71.82,217.858h0c-.975,.081-1.764-.733-1.764-1.818v-40.322c0-1.085,.788-2.095,1.764-2.257h0c.979-.163,1.775,.59,1.775,1.682v40.59c0,1.092-.796,2.043-1.775,2.124Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.841,200.136v-7.711c0-2.147,1.553-4.104,3.481-4.372l3.003-.418c1.965-.274,3.568,1.277,3.568,3.465v7.858c0,2.188-1.603,4.138-3.568,4.354l-3.003,.33c-1.928,.212-3.481-1.358-3.481-3.505Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M87.264,216.578h0c-1.033,.086-1.867-.75-1.867-1.866v-41.486c0-1.116,.834-2.159,1.867-2.331h0c1.037-.172,1.88,.598,1.88,1.722v41.77c0,1.124-.843,2.104-1.88,2.19Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.994,198.359v-7.932c0-2.209,1.643-4.228,3.685-4.512l3.179-.443c2.081-.29,3.779,1.3,3.779,3.552v8.087c0,2.252-1.698,4.264-3.779,4.493l-3.179,.349c-2.041,.224-3.685-1.386-3.685-3.594Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M103.629,215.221h0c-1.095,.091-1.98-.767-1.98-1.917v-42.719c0-1.149,.885-2.228,1.98-2.41h0c1.099-.183,1.994,.607,1.994,1.764v43.02c0,1.157-.894,2.17-1.994,2.261Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.041,196.478v-8.166c0-2.274,1.742-4.36,3.906-4.661l3.372-.469c2.207-.307,4.009,1.323,4.009,3.642v8.331c0,2.32-1.802,4.399-4.009,4.641l-3.372,.371c-2.164,.238-3.906-1.414-3.906-3.688Z",
    fill: "#7f5640"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M6.035,281.979h0c-.75-.032-1.356-.829-1.356-1.78v-35.361c0-.951,.606-1.747,1.356-1.777h0c.752-.031,1.364,.72,1.364,1.677v35.567c0,.957-.612,1.706-1.364,1.674Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.204,265.9v-6.767c0-1.884,1.196-3.428,2.679-3.449l2.308-.032c1.508-.021,2.737,1.516,2.737,3.431v6.88c0,1.916-1.229,3.45-2.737,3.426l-2.308-.036c-1.484-.023-2.679-1.569-2.679-3.454Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M17.86,282.483h0c-.788-.034-1.425-.851-1.425-1.827v-36.253c0-.975,.637-1.792,1.425-1.824h0c.791-.032,1.434,.737,1.434,1.718v36.47c0,.981-.643,1.749-1.434,1.715Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.834,265.996v-6.937c0-1.932,1.256-3.515,2.816-3.536l2.426-.033c1.586-.022,2.879,1.553,2.879,3.518v7.055c0,1.965-1.293,3.537-2.878,3.512l-2.426-.038c-1.559-.024-2.816-1.61-2.816-3.542Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M30.299,283.013h0c-.83-.035-1.5-.875-1.5-1.875v-37.191c0-1,.67-1.839,1.5-1.872h0c.832-.034,1.509,.755,1.509,1.761v37.419c0,1.007-.677,1.794-1.509,1.758Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.063,266.098v-7.115c0-1.981,1.322-3.606,2.963-3.628l2.553-.035c1.669-.023,3.031,1.593,3.031,3.609v7.24c0,2.016-1.361,3.629-3.031,3.603l-2.553-.04c-1.641-.026-2.963-1.653-2.963-3.634Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M43.402,283.572h0c-.874-.037-1.581-.9-1.581-1.927v-38.179c0-1.027,.707-1.888,1.581-1.924h0c.877-.036,1.591,.773,1.591,1.807v38.42c0,1.034-.714,1.841-1.591,1.804Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.938,266.204v-7.303c0-2.034,1.393-3.701,3.122-3.725l2.691-.037c1.76-.024,3.195,1.635,3.195,3.705v7.435c0,2.07-1.435,3.726-3.195,3.699l-2.691-.042c-1.729-.027-3.122-1.697-3.122-3.731Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M57.222,284.161h0c-.923-.039-1.669-.926-1.669-1.981v-39.221c0-1.055,.746-1.941,1.669-1.978h0c.926-.038,1.679,.793,1.679,1.854v39.475c0,1.062-.753,1.891-1.679,1.851Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.511,266.317v-7.502c0-2.089,1.47-3.802,3.294-3.827l2.841-.039c1.858-.025,3.374,1.679,3.374,3.806v7.64c0,2.128-1.516,3.829-3.374,3.8l-2.841-.044c-1.825-.028-3.295-1.745-3.295-3.834Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M71.82,284.783h0c-.975-.042-1.764-.954-1.764-2.039v-40.322c0-1.085,.788-1.996,1.764-2.036h0c.979-.04,1.775,.813,1.775,1.905v40.59c0,1.092-.796,1.943-1.775,1.901Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.841,266.435v-7.711c0-2.147,1.553-3.909,3.481-3.935l3.003-.041c1.965-.027,3.568,1.725,3.568,3.913v7.858c0,2.188-1.603,3.937-3.568,3.906l-3.003-.047c-1.928-.03-3.481-1.795-3.481-3.942Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M87.264,285.441h0c-1.033-.044-1.867-.984-1.867-2.1v-41.485c0-1.116,.834-2.055,1.867-2.097h0c1.037-.042,1.88,.834,1.88,1.958v41.77c0,1.124-.843,1.999-1.88,1.954Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.994,266.561v-7.932c0-2.209,1.643-4.022,3.685-4.05l3.179-.044c2.081-.029,3.779,1.774,3.779,4.026v8.087c0,2.252-1.698,4.051-3.779,4.019l-3.179-.05c-2.041-.032-3.685-1.848-3.685-4.057Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M103.629,286.138h0c-1.095-.047-1.98-1.016-1.98-2.165v-42.719c0-1.149,.885-2.117,1.98-2.161h0c1.099-.045,1.994,.857,1.994,2.014v43.02c0,1.157-.894,2.057-1.994,2.01Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.041,266.694v-8.166c0-2.274,1.742-4.141,3.906-4.171l3.372-.046c2.207-.03,4.009,1.826,4.009,4.146v8.331c0,2.32-1.802,4.172-4.009,4.138l-3.372-.053c-2.164-.034-3.906-1.905-3.906-4.179Z",
    fill: "#7f5640"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M6.035,340.646h0c-.75-.126-1.356-.999-1.356-1.95v-35.361c0-.951,.606-1.671,1.356-1.607h0c.752,.064,1.364,.891,1.364,1.848v35.567c0,.957-.612,1.63-1.364,1.503Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.204,324.086v-6.767c0-1.884,1.196-3.278,2.679-3.112l2.308,.258c1.508,.169,2.737,1.859,2.737,3.775v6.88c0,1.916-1.229,3.295-2.737,3.083l-2.308-.326c-1.484-.209-2.679-1.906-2.679-3.79Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M17.86,342.634h0c-.788-.133-1.425-1.03-1.425-2.005v-36.253c0-.975,.637-1.712,1.425-1.645h0c.791,.067,1.434,.917,1.434,1.898v36.47c0,.981-.643,1.668-1.434,1.535Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.834,325.642v-6.937c0-1.932,1.256-3.357,2.816-3.183l2.426,.271c1.586,.177,2.879,1.915,2.879,3.879v7.055c0,1.965-1.293,3.375-2.878,3.151l-2.426-.342c-1.559-.22-2.816-1.963-2.816-3.895Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M30.299,344.726h0c-.83-.139-1.5-1.063-1.5-2.064v-37.191c0-1,.67-1.755,1.5-1.684h0c.832,.071,1.509,.944,1.509,1.951v37.419c0,1.007-.677,1.709-1.509,1.569Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.063,327.278v-7.115c0-1.981,1.322-3.44,2.963-3.256l2.553,.285c1.669,.187,3.031,1.973,3.031,3.99v7.24c0,2.016-1.361,3.458-3.031,3.223l-2.553-.36c-1.641-.232-2.963-2.025-2.963-4.006Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M43.402,346.929h0c-.874-.147-1.581-1.098-1.581-2.125v-38.179c0-1.027,.707-1.8,1.581-1.725h0c.877,.074,1.591,.973,1.591,2.006v38.42c0,1.034-.714,1.751-1.591,1.604Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.938,329.001v-7.303c0-2.034,1.393-3.527,3.122-3.333l2.691,.301c1.76,.197,3.195,2.036,3.195,4.106v7.435c0,2.07-1.435,3.546-3.195,3.298l-2.691-.38c-1.729-.244-3.122-2.089-3.122-4.123Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M57.222,349.253h0c-.923-.155-1.669-1.136-1.669-2.191v-39.221c0-1.055,.746-1.847,1.669-1.769h0c.926,.079,1.679,1.003,1.679,2.065v39.475c0,1.062-.753,1.796-1.679,1.64Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.511,330.817v-7.502c0-2.089,1.47-3.618,3.294-3.414l2.841,.318c1.858,.208,3.374,2.102,3.374,4.23v7.64c0,2.128-1.516,3.638-3.374,3.376l-2.841-.401c-1.825-.258-3.295-2.158-3.295-4.247Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M71.82,351.707h0c-.975-.164-1.764-1.176-1.764-2.261v-40.321c0-1.085,.788-1.897,1.764-1.814h0c.979,.083,1.775,1.036,1.775,2.128v40.59c0,1.092-.796,1.843-1.775,1.679Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.841,332.735v-7.711c0-2.147,1.553-3.714,3.481-3.499l3.003,.336c1.965,.22,3.568,2.173,3.568,4.361v7.858c0,2.188-1.603,3.736-3.568,3.458l-3.003-.424c-1.928-.272-3.481-2.232-3.481-4.379Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M87.264,354.304h0c-1.033-.174-1.867-1.219-1.867-2.335v-41.485c0-1.116,.834-1.95,1.867-1.862h0c1.037,.088,1.88,1.07,1.88,2.194v41.77c0,1.124-.843,1.893-1.88,1.718Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.994,334.762v-7.932c0-2.209,1.643-3.816,3.685-3.587l3.179,.355c2.081,.233,3.779,2.248,3.779,4.5v8.087c0,2.252-1.698,3.838-3.779,3.544l-3.179-.449c-2.041-.288-3.685-2.311-3.685-4.52Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M103.629,357.056h0c-1.095-.184-1.98-1.264-1.98-2.414v-42.719c0-1.149,.885-2.006,1.98-1.913h0c1.099,.093,1.994,1.107,1.994,2.265v43.02c0,1.157-.894,1.945-1.994,1.76Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.041,336.91v-8.166c0-2.274,1.742-3.923,3.906-3.681l3.372,.377c2.207,.247,4.009,2.329,4.009,4.649v8.331c0,2.32-1.802,3.946-4.009,3.635l-3.372-.476c-2.164-.305-3.906-2.395-3.906-4.669Z",
    fill: "#7f5640"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M6.035,399.313h0c-.75-.22-1.356-1.169-1.356-2.121v-35.361c0-.951,.606-1.595,1.356-1.437h0c.752,.158,1.364,1.063,1.364,2.019v35.567c0,.957-.612,1.553-1.364,1.332Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.204,382.272v-6.767c0-1.884,1.196-3.128,2.679-2.776l2.308,.548c1.508,.358,2.737,2.203,2.737,4.119v6.88c0,1.916-1.229,3.141-2.737,2.739l-2.308-.615c-1.484-.396-2.679-2.242-2.679-4.127Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M17.86,402.786h0c-.788-.231-1.425-1.209-1.425-2.184v-36.253c0-.975,.637-1.632,1.425-1.466h0c.791,.166,1.434,1.097,1.434,2.078v36.47c0,.981-.643,1.588-1.434,1.355Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.834,385.288v-6.937c0-1.932,1.256-3.199,2.816-2.829l2.426,.576c1.586,.376,2.879,2.276,2.879,4.241v7.055c0,1.965-1.293,3.213-2.878,2.79l-2.426-.647c-1.559-.416-2.816-2.317-2.816-4.249Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M30.299,406.439h0c-.83-.244-1.5-1.252-1.5-2.252v-37.191c0-1,.67-1.67,1.5-1.496h0c.832,.175,1.509,1.134,1.509,2.14v37.419c0,1.007-.677,1.624-1.509,1.379Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.063,388.459v-7.115c0-1.981,1.322-3.274,2.963-2.884l2.553,.606c1.669,.396,3.031,2.354,3.031,4.37v7.24c0,2.016-1.361,3.287-3.031,2.842l-2.553-.681c-1.641-.438-2.963-2.396-2.963-4.378Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M43.402,410.286h0c-.874-.257-1.581-1.297-1.581-2.324v-38.179c0-1.027,.707-1.711,1.581-1.527h0c.877,.185,1.591,1.173,1.591,2.206v38.42c0,1.034-.714,1.662-1.591,1.404Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.938,391.798v-7.303c0-2.034,1.393-3.352,3.122-2.941l2.691,.639c1.76,.418,3.195,2.437,3.195,4.507v7.435c0,2.07-1.435,3.366-3.195,2.897l-2.691-.718c-1.729-.461-3.122-2.481-3.122-4.515Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M57.222,414.345h0c-.923-.271-1.669-1.345-1.669-2.4v-39.221c0-1.055,.746-1.754,1.669-1.559h0c.926,.195,1.679,1.214,1.679,2.276v39.475c0,1.062-.753,1.702-1.679,1.43Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.511,395.318v-7.502c0-2.089,1.47-3.433,3.294-3l2.841,.674c1.858,.441,3.374,2.526,3.374,4.653v7.64c0,2.128-1.516,3.448-3.374,2.953l-2.841-.757c-1.825-.487-3.295-2.572-3.295-4.661Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M71.82,418.632h0c-.975-.286-1.764-1.397-1.764-2.482v-40.321c0-1.085,.788-1.798,1.764-1.593h0c.979,.206,1.775,1.259,1.775,2.351v40.59c0,1.092-.796,1.743-1.775,1.456Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.841,399.034v-7.711c0-2.147,1.553-3.519,3.481-3.062l3.003,.713c1.965,.466,3.568,2.621,3.568,4.809v7.858c0,2.188-1.603,3.534-3.568,3.01l-3.003-.801c-1.928-.514-3.481-2.669-3.481-4.816Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M87.264,423.167h0c-1.033-.303-1.867-1.453-1.867-2.569v-41.485c0-1.116,.834-1.845,1.867-1.628h0c1.037,.218,1.88,1.306,1.88,2.43v41.77c0,1.124-.843,1.787-1.88,1.482Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.994,402.964v-7.932c0-2.209,1.643-3.609,3.685-3.125l3.179,.755c2.081,.494,3.779,2.723,3.779,4.975v8.087c0,2.252-1.698,3.625-3.779,3.07l-3.179-.848c-2.041-.544-3.685-2.773-3.685-4.982Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M103.629,427.973h0c-1.095-.322-1.98-1.513-1.98-2.662v-42.719c0-1.149,.885-1.895,1.98-1.664h0c1.099,.231,1.994,1.358,1.994,2.515v43.02c0,1.157-.894,1.833-1.994,1.51Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.041,407.125v-8.166c0-2.274,1.742-3.704,3.906-3.19l3.372,.8c2.207,.524,4.009,2.832,4.009,5.152v8.331c0,2.32-1.802,3.72-4.009,3.131l-3.372-.899c-2.164-.577-3.906-2.885-3.906-5.159Z",
    fill: "#7f5640"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M6.358,472.936h0c-.787-.348-1.424-1.38-1.424-2.306l-.002-34.406c0-.925,.636-1.431,1.423-1.128h0c.789,.303,1.43,1.303,1.43,2.232l.003,34.557c0,.93-.641,1.4-1.43,1.051Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.33,455.644v-6.593c0-1.836,1.259-2.816,2.818-2.188l2.421,.976c1.579,.636,2.865,2.661,2.865,4.52v6.676c.001,1.859-1.284,2.822-2.864,2.153l-2.422-1.025c-1.56-.661-2.819-2.682-2.819-4.519Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M18.693,478.392h0c-.817-.361-1.479-1.419-1.479-2.362l-.008-35.057c0-.943,.66-1.453,1.477-1.139h0c.819,.315,1.484,1.338,1.485,2.285l.009,35.214c0,.948-.665,1.422-1.485,1.059Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.508,460.739v-6.717c-.002-1.87,1.305-2.86,2.924-2.207l2.514,1.013c1.639,.661,2.975,2.734,2.975,4.629l.002,6.803c0,1.895-1.334,2.865-2.974,2.171l-2.514-1.065c-1.619-.686-2.927-2.756-2.927-4.627Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M31.503,484.057h0c-.849-.376-1.536-1.459-1.537-2.421l-.013-35.734c0-.961,.686-1.476,1.534-1.15h0c.851,.327,1.542,1.375,1.543,2.34l.015,35.897c0,.966-.691,1.443-1.542,1.067Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.154,466.029l-.002-6.846c0-1.906,1.356-2.904,3.038-2.227l2.611,1.052c1.703,.687,3.091,2.811,3.092,4.742l.003,6.936c0,1.932-1.386,2.91-3.089,2.188l-2.612-1.106c-1.682-.712-3.04-2.833-3.041-4.74Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M44.817,489.946h0c-.883-.39-1.597-1.501-1.598-2.482l-.02-36.437c0-.98,.713-1.5,1.595-1.161h0c.885,.34,1.604,1.414,1.604,2.398l.021,36.607c0,.985-.718,1.466-1.603,1.074Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.293,471.526l-.004-6.981c0-1.944,1.409-2.951,3.157-2.246l2.715,1.094c1.771,.714,3.215,2.892,3.216,4.861l.004,7.073c.001,1.97-1.441,2.956-3.212,2.206l-2.716-1.15c-1.749-.741-3.161-2.914-3.162-4.858Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M58.665,496.071h0c-.919-.406-1.662-1.546-1.663-2.546l-.026-37.168c0-.999,.741-1.524,1.659-1.171h0c.92,.354,1.669,1.455,1.67,2.459l.028,37.345c0,1.005-.747,1.489-1.668,1.082Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.955,477.242l-.005-7.12c-.001-1.982,1.465-2.998,3.284-2.265l2.825,1.139c1.843,.743,3.346,2.977,3.348,4.986l.006,7.217c.002,2.01-1.499,3.003-3.342,2.223l-2.826-1.197c-1.819-.77-3.289-3-3.29-4.983Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M73.079,502.446h0c-.956-.423-1.731-1.593-1.732-2.614l-.034-37.93c0-1.02,.771-1.55,1.727-1.182h0c.958,.368,1.738,1.498,1.739,2.523l.036,38.114c0,1.026-.778,1.513-1.737,1.089Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.173,483.19l-.006-7.265c-.002-2.023,1.525-3.047,3.419-2.284l2.942,1.186c1.92,.774,3.485,3.066,3.487,5.117l.007,7.366c.002,2.051-1.56,3.052-3.48,2.239l-2.942-1.246c-1.894-.802-3.424-3.09-3.426-5.113Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M88.096,509.088h0c-.997-.441-1.804-1.642-1.805-2.685l-.042-38.723c-.001-1.041,.804-1.576,1.8-1.193h0c.999,.384,1.812,1.544,1.813,2.59l.044,38.915c.001,1.047-.81,1.537-1.81,1.095Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.981,489.384l-.008-7.417c-.002-2.065,1.588-3.097,3.562-2.302l3.066,1.236c2.001,.806,3.633,3.161,3.636,5.255l.009,7.521c.002,2.095-1.626,3.102-3.627,2.255l-3.067-1.299c-1.974-.836-3.568-3.185-3.57-5.25Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M103.754,516.013h0c-1.04-.46-1.882-1.695-1.883-2.759l-.05-39.55c-.001-1.063,.838-1.603,1.877-1.203h0c1.042,.4,1.89,1.592,1.891,2.661l.052,39.75c.001,1.07-.845,1.562-1.888,1.101Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.415,495.842l-.009-7.574c-.003-2.109,1.656-3.149,3.714-2.32l3.198,1.289c2.088,.841,3.791,3.261,3.794,5.401l.011,7.684c.003,2.14-1.696,3.154-3.784,2.27l-3.199-1.355c-2.059-.872-3.722-3.285-3.724-5.395Z",
    fill: "#7f5640"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M6.363,530.046h0c-.788-.417-1.425-1.507-1.425-2.434l-.002-34.455c0-.926,.637-1.377,1.424-1.006h0c.789,.372,1.431,1.429,1.431,2.36l.003,34.606c0,.931-.641,1.346-1.431,.928Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.331,512.377v-6.602c0-1.838,1.259-2.71,2.82-1.945l2.423,1.189c1.58,.775,2.867,2.915,2.867,4.777v6.685c.001,1.862-1.285,2.714-2.866,1.906l-2.423-1.238c-1.561-.798-2.821-2.932-2.821-4.771Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M18.707,536.586h0c-.818-.433-1.48-1.55-1.48-2.495l-.008-35.108c0-.944,.661-1.397,1.478-1.012h0c.82,.387,1.486,1.469,1.486,2.418l.009,35.266c0,.949-.666,1.366-1.486,.931Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.519,518.543v-6.727c-.002-1.873,1.306-2.75,2.926-1.955l2.516,1.234c1.641,.805,2.977,2.998,2.978,4.895l.002,6.813c0,1.897-1.335,2.753-2.976,1.914l-2.516-1.286c-1.621-.828-2.929-3.015-2.929-4.889Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M31.526,543.379h0c-.85-.45-1.537-1.595-1.538-2.558l-.013-35.786c0-.962,.686-1.418,1.536-1.018h0c.851,.402,1.544,1.512,1.544,2.478l.015,35.95c0,.968-.691,1.385-1.543,.934Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.174,524.945l-.002-6.856c0-1.909,1.357-2.79,3.04-1.965l2.613,1.282c1.705,.836,3.094,3.085,3.095,5.019l.003,6.946c0,1.934-1.387,2.793-3.092,1.922l-2.614-1.336c-1.684-.86-3.043-3.103-3.043-5.012Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M44.851,550.439h0c-.883-.468-1.598-1.643-1.599-2.625l-.02-36.492c0-.981,.713-1.44,1.596-1.023h0c.885,.418,1.605,1.556,1.606,2.542l.021,36.662c0,.987-.719,1.405-1.604,.936Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.323,531.597l-.004-6.991c0-1.947,1.41-2.832,3.16-1.973l2.717,1.333c1.773,.87,3.217,3.177,3.219,5.149l.004,7.084c.001,1.973-1.442,2.834-3.215,1.928l-2.718-1.389c-1.75-.894-3.163-3.195-3.164-5.142Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M58.71,557.782h0c-.919-.487-1.663-1.693-1.664-2.695l-.026-37.225c0-1.001,.742-1.462,1.661-1.028h0c.921,.435,1.67,1.603,1.671,2.609l.028,37.403c0,1.007-.748,1.426-1.669,.938Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.996,538.514l-.005-7.131c-.001-1.985,1.466-2.874,3.287-1.981l2.827,1.387c1.845,.905,3.349,3.273,3.35,5.286l.006,7.228c.002,2.013-1.5,2.877-3.345,1.934l-2.828-1.445c-1.821-.93-3.291-3.291-3.293-5.277Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M73.137,565.427h0c-.957-.507-1.732-1.746-1.733-2.769l-.034-37.989c0-1.021,.772-1.484,1.729-1.033h0c.959,.453,1.74,1.652,1.741,2.679l.036,38.174c0,1.027-.778,1.447-1.738,.938Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.226,545.713l-.006-7.277c-.002-2.026,1.526-2.918,3.422-1.988l2.944,1.444c1.921,.943,3.488,3.375,3.49,5.43l.007,7.378c.002,2.055-1.562,2.92-3.483,1.938l-2.945-1.505c-1.896-.969-3.427-3.393-3.429-5.42Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M88.167,573.391h0c-.998-.529-1.805-1.802-1.807-2.846l-.042-38.785c-.001-1.043,.804-1.508,1.801-1.037h0c1,.472,1.813,1.705,1.815,2.753l.044,38.978c.001,1.049-.811,1.469-1.811,.939Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.047,553.211l-.008-7.428c-.002-2.068,1.59-2.963,3.565-1.994l3.069,1.505c2.003,.982,3.636,3.483,3.639,5.581l.009,7.534c.002,2.098-1.627,2.965-3.631,1.941l-3.069-1.568c-1.976-1.01-3.571-3.501-3.574-5.57Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M103.839,581.695h0c-1.041-.551-1.883-1.862-1.885-2.928l-.05-39.615c-.001-1.065,.839-1.532,1.879-1.041h0c1.043,.492,1.892,1.76,1.893,2.83l.052,39.816c.001,1.072-.846,1.491-1.889,.938Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.495,561.026l-.009-7.587c-.003-2.112,1.657-3.009,3.717-1.999l3.201,1.57c2.09,1.025,3.794,3.597,3.797,5.74l.011,7.696c.003,2.143-1.697,3.011-3.787,1.943l-3.202-1.636c-2.061-1.053-3.725-3.615-3.728-5.728Z",
    fill: "#7f5640"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M6.368,587.236h0c-.788-.487-1.426-1.633-1.426-2.562l-.002-34.504c0-.928,.637-1.323,1.425-.883h0c.79,.442,1.432,1.556,1.432,2.488l.003,34.656c0,.933-.642,1.292-1.432,.804Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.333,569.19v-6.612c0-1.841,1.26-2.604,2.822-1.701l2.425,1.402c1.581,.914,2.869,3.17,2.869,5.034v6.695c.001,1.864-1.286,2.605-2.868,1.658l-2.425-1.452c-1.562-.935-2.823-3.183-2.823-5.024Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M18.72,594.865h0c-.819-.505-1.481-1.681-1.481-2.628l-.008-35.159c0-.945,.661-1.342,1.479-.884h0c.82,.459,1.487,1.601,1.487,2.551l.009,35.317c0,.95-.666,1.309-1.487,.803Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.529,576.43v-6.737c-.002-1.876,1.307-2.64,2.928-1.702l2.517,1.456c1.642,.949,2.979,3.262,2.98,5.162l.002,6.823c0,1.9-1.336,2.64-2.978,1.657l-2.518-1.507c-1.622-.971-2.931-3.276-2.931-5.152Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M31.55,602.788h0c-.85-.525-1.539-1.732-1.539-2.696l-.013-35.839c0-.964,.687-1.36,1.537-.885h0c.852,.477,1.545,1.649,1.545,2.617l.015,36.004c0,.969-.692,1.327-1.545,.8Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.194,583.947l-.002-6.867c0-1.912,1.358-2.676,3.043-1.702l2.616,1.512c1.706,.986,3.096,3.36,3.097,5.297l.003,6.956c0,1.937-1.388,2.676-3.094,1.654l-2.616-1.566c-1.685-1.009-3.045-3.373-3.046-5.285Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M44.885,611.023h0c-.884-.546-1.6-1.785-1.6-2.769l-.02-36.547c0-.983,.714-1.379,1.598-.885h0c.886,.496,1.606,1.699,1.607,2.686l.021,36.718c0,.988-.719,1.344-1.606,.797Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.353,591.758l-.004-7.002c0-1.949,1.411-2.713,3.163-1.7l2.719,1.572c1.774,1.026,3.22,3.463,3.221,5.438l.004,7.095c.001,1.976-1.443,2.713-3.217,1.65l-2.72-1.628c-1.752-1.049-3.166-3.476-3.167-5.426Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M58.755,619.589h0c-.92-.568-1.665-1.841-1.665-2.845l-.027-37.283c0-1.002,.742-1.399,1.662-.885h0c.922,.516,1.672,1.751,1.672,2.759l.028,37.461c0,1.008-.748,1.363-1.671,.793Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.038,599.881l-.005-7.142c-.001-1.989,1.468-2.75,3.29-1.697l2.83,1.636c1.846,1.068,3.352,3.571,3.353,5.587l.006,7.239c.002,2.016-1.501,2.75-3.348,1.644l-2.83-1.694c-1.822-1.091-3.294-3.584-3.295-5.573Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M73.194,628.506h0c-.958-.592-1.734-1.9-1.735-2.924l-.034-38.049c0-1.023,.773-1.419,1.73-.884h0c.96,.537,1.741,1.807,1.742,2.835l.036,38.234c0,1.029-.779,1.381-1.74,.788Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.279,608.334l-.006-7.288c-.002-2.029,1.527-2.789,3.425-1.692l2.947,1.704c1.923,1.112,3.491,3.685,3.493,5.743l.007,7.389c.002,2.058-1.563,2.788-3.486,1.637l-2.948-1.765c-1.898-1.136-3.43-3.698-3.432-5.728Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M88.238,637.797h0c-.999-.617-1.807-1.963-1.808-3.009l-.042-38.847c-.001-1.045,.805-1.44,1.803-.881h0c1.001,.56,1.815,1.866,1.816,2.915l.044,39.04c.001,1.051-.812,1.4-1.813,.782Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.113,617.138l-.008-7.44c-.002-2.072,1.591-2.829,3.568-1.686l3.072,1.776c2.005,1.159,3.64,3.806,3.642,5.908l.009,7.546c.002,2.101-1.629,2.827-3.634,1.627l-3.072-1.839c-1.978-1.184-3.575-3.819-3.577-5.891Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M103.924,647.484h0c-1.042-.643-1.885-2.029-1.887-3.097l-.05-39.68c-.001-1.067,.839-1.461,1.88-.878h0c1.044,.584,1.894,1.928,1.895,3l.053,39.881c.001,1.073-.846,1.419-1.891,.774Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.576,626.317l-.009-7.599c-.003-2.116,1.659-2.869,3.721-1.677l3.204,1.853c2.092,1.209,3.798,3.935,3.801,6.081l.011,7.709c.003,2.147-1.699,2.867-3.791,1.615l-3.205-1.919c-2.063-1.235-3.729-3.947-3.731-6.063Z",
    fill: "#7f5640"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M6.372,644.509h0c-.789-.557-1.427-1.761-1.427-2.69l-.002-34.553c0-.929,.638-1.269,1.426-.759h0c.79,.512,1.433,1.684,1.433,2.617l.003,34.705c0,.934-.642,1.238-1.433,.68Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.335,626.084v-6.621c0-1.844,1.261-2.498,2.824-1.457l2.426,1.616c1.582,1.054,2.871,3.425,2.871,5.292v6.704c.001,1.867-1.287,2.496-2.87,1.41l-2.427-1.666c-1.563-1.073-2.825-3.434-2.825-5.278Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M18.734,653.229h0c-.819-.578-1.482-1.813-1.482-2.761l-.008-35.21c0-.947,.662-1.286,1.481-.756h0c.821,.531,1.488,1.734,1.488,2.685l.009,35.368c0,.952-.667,1.253-1.488,.674Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.54,634.4v-6.746c-.002-1.878,1.308-2.529,2.93-1.448l2.519,1.678c1.643,1.094,2.982,3.528,2.982,5.43l.002,6.833c0,1.903-1.337,2.527-2.981,1.399l-2.52-1.73c-1.623-1.114-2.933-3.537-2.934-5.416Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M31.573,662.285h0c-.851-.6-1.54-1.869-1.54-2.835l-.013-35.892c0-.965,.687-1.302,1.538-.752h0c.853,.552,1.546,1.786,1.546,2.756l.015,36.057c0,.97-.693,1.268-1.546,.666Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.214,643.036l-.002-6.877c0-1.915,1.359-2.561,3.045-1.438l2.618,1.743c1.707,1.137,3.099,3.636,3.1,5.575l.003,6.967c0,1.94-1.389,2.558-3.097,1.386l-2.618-1.797c-1.686-1.157-3.047-3.644-3.048-5.559Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M44.919,671.699h0c-.885-.624-1.601-1.928-1.602-2.913l-.02-36.602c0-.984,.714-1.319,1.599-.747h0c.887,.574,1.608,1.842,1.608,2.83l.021,36.773c0,.99-.72,1.284-1.607,.658Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.384,652.009l-.004-7.012c0-1.952,1.412-2.593,3.165-1.426l2.722,1.813c1.776,1.182,3.223,3.749,3.224,5.728l.004,7.106c.001,1.979-1.444,2.59-3.22,1.371l-2.722-1.869c-1.753-1.203-3.168-3.758-3.169-5.711Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M58.801,681.491h0c-.921-.65-1.666-1.99-1.667-2.995l-.027-37.34c0-1.004,.743-1.336,1.663-.741h0c.923,.597,1.673,1.9,1.674,2.909l.028,37.518c0,1.01-.749,1.299-1.672,.648Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.079,661.341l-.005-7.153c-.001-1.992,1.469-2.626,3.292-1.412l2.832,1.886c1.848,1.231,3.354,3.869,3.356,5.888l.006,7.25c.002,2.019-1.502,2.623-3.351,1.354l-2.833-1.945c-1.824-1.252-3.297-3.877-3.298-5.869Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M73.252,691.685h0c-.959-.676-1.735-2.055-1.736-3.081l-.034-38.109c0-1.025,.773-1.354,1.732-.734h0c.961,.622,1.743,1.962,1.744,2.992l.036,38.294c0,1.031-.78,1.315-1.741,.637Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.333,671.053l-.006-7.299c-.002-2.032,1.529-2.66,3.428-1.395l2.949,1.964c1.925,1.282,3.494,3.996,3.496,6.057l.007,7.401c.002,2.061-1.564,2.656-3.489,1.334l-2.95-2.025c-1.899-1.304-3.433-4.004-3.435-6.037Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M88.309,702.306h0c-1-.705-1.809-2.124-1.81-3.171l-.042-38.909c-.001-1.046,.806-1.372,1.805-.725h0c1.002,.648,1.817,2.027,1.818,3.079l.044,39.103c.001,1.052-.812,1.331-1.815,.624Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.179,681.168l-.008-7.452c-.002-2.075,1.592-2.694,3.571-1.376l3.074,2.047c2.006,1.336,3.643,4.131,3.646,6.235l.009,7.558c.002,2.105-1.63,2.689-3.637,1.311l-3.075-2.111c-1.979-1.359-3.578-4.138-3.58-6.213Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M104.01,713.382h0c-1.043-.736-1.887-2.197-1.888-3.267l-.051-39.745c-.001-1.069,.84-1.39,1.882-.715h0c1.045,.676,1.895,2.096,1.897,3.171l.053,39.947c.001,1.075-.847,1.347-1.893,.61Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.656,691.714l-.009-7.611c-.003-2.119,1.66-2.728,3.724-1.354l3.207,2.136c2.093,1.394,3.802,4.273,3.805,6.423l.011,7.722c.003,2.15-1.701,2.723-3.795,1.285l-3.208-2.202c-2.065-1.417-3.732-4.279-3.735-6.399Z",
    fill: "#7f5640"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M6.377,701.863h0c-.79-.626-1.428-1.888-1.428-2.819l-.002-34.602c0-.93,.638-1.215,1.427-.635h0c.791,.581,1.434,1.811,1.434,2.746l.003,34.755c0,.935-.643,1.184-1.434,.556Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.336,683.059v-6.63c0-1.846,1.262-2.391,2.826-1.212l2.428,1.83c1.584,1.194,2.873,3.681,2.873,5.551v6.714c.001,1.87-1.288,2.387-2.872,1.161l-2.429-1.881c-1.564-1.212-2.827-3.686-2.827-5.533Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M18.748,711.677h0c-.82-.65-1.483-1.946-1.483-2.895l-.008-35.261c0-.948,.662-1.23,1.482-.627h0c.821,.604,1.489,1.866,1.489,2.819l.009,35.42c0,.953-.667,1.196-1.489,.544Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.55,692.455v-6.756c-.002-1.881,1.309-2.418,2.933-1.194l2.521,1.901c1.644,1.24,2.984,3.794,2.984,5.699l.002,6.843c0,1.906-1.338,2.414-2.983,1.14l-2.522-1.953c-1.624-1.258-2.935-3.798-2.936-5.68Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M31.597,721.871h0c-.852-.676-1.541-2.007-1.541-2.974l-.013-35.946c0-.967,.688-1.244,1.539-.618h0c.853,.627,1.547,1.924,1.548,2.895l.015,36.111c0,.972-.693,1.209-1.547,.532Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.234,702.212l-.002-6.887c0-1.918,1.36-2.446,3.047-1.174l2.62,1.975c1.709,1.288,3.101,3.912,3.102,5.855l.003,6.977c0,1.943-1.39,2.441-3.099,1.117l-2.62-2.029c-1.687-1.307-3.05-3.916-3.05-5.834Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M44.953,732.467h0c-.886-.703-1.602-2.071-1.603-3.057l-.02-36.657c0-.986,.715-1.258,1.6-.608h0c.887,.652,1.609,1.985,1.61,2.975l.021,36.829c0,.991-.72,1.222-1.608,.518Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.414,712.351l-.004-7.023c0-1.955,1.414-2.473,3.168-1.151l2.724,2.053c1.777,1.34,3.225,4.037,3.227,6.018l.004,7.117c.001,1.982-1.445,2.468-3.223,1.091l-2.724-2.11c-1.754-1.359-3.171-4.041-3.172-5.996Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M58.846,743.489h0c-.922-.731-1.668-2.138-1.668-3.145l-.027-37.398c0-1.006,.744-1.273,1.665-.596h0c.923,.679,1.675,2.049,1.675,3.06l.028,37.576c0,1.011-.749,1.236-1.673,.502Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.121,722.895l-.005-7.164c-.001-1.995,1.47-2.501,3.295-1.126l2.835,2.137c1.849,1.394,3.357,4.169,3.359,6.191l.006,7.262c.002,2.022-1.504,2.495-3.353,1.063l-2.835-2.195c-1.825-1.414-3.299-4.172-3.301-6.167Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M73.31,754.964h0c-.96-.761-1.737-2.21-1.738-3.237l-.034-38.168c0-1.026,.774-1.288,1.733-.583h0c.962,.707,1.744,2.117,1.745,3.149l.036,38.355c0,1.032-.78,1.249-1.743,.485Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.386,733.87l-.006-7.311c-.002-2.036,1.53-2.53,3.43-1.097l2.952,2.225c1.926,1.452,3.497,4.308,3.499,6.372l.007,7.413c.002,2.064-1.566,2.523-3.493,1.031l-2.953-2.287c-1.901-1.472-3.436-4.31-3.438-6.346Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M88.38,766.92h0c-1-.794-1.81-2.286-1.811-3.335l-.042-38.972c-.001-1.048,.806-1.303,1.806-.568h0c1.003,.737,1.818,2.189,1.819,3.242l.044,39.166c.001,1.054-.813,1.262-1.816,.466Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.246,745.3l-.008-7.464c-.002-2.078,1.594-2.558,3.574-1.065l3.077,2.32c2.008,1.514,3.646,4.456,3.649,6.564l.009,7.57c.002,2.108-1.632,2.55-3.64,.995l-3.078-2.383c-1.981-1.534-3.581-4.457-3.583-6.536Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M104.095,779.387h0c-1.044-.828-1.889-2.366-1.89-3.438l-.051-39.81c-.001-1.07,.841-1.318,1.884-.552h0c1.046,.769,1.897,2.266,1.899,3.341l.053,40.013c.001,1.077-.848,1.275-1.895,.445Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.736,757.217l-.009-7.624c-.003-2.123,1.662-2.587,3.728-1.03l3.21,2.42c2.095,1.58,3.805,4.613,3.808,6.766l.011,7.735c.003,2.154-1.702,2.578-3.798,.955l-3.211-2.486c-2.067-1.6-3.736-4.613-3.738-6.736Z",
    fill: "#7f5640"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M6.381,759.299h0c-.79-.696-1.429-2.016-1.429-2.948l-.002-34.651c0-.932,.639-1.161,1.428-.511h0c.792,.651,1.435,1.939,1.435,2.875l.003,34.805c0,.937-.643,1.129-1.435,.431Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.338,740.115v-6.64c0-1.849,1.263-2.284,2.828-.966l2.43,2.046c1.585,1.334,2.875,3.938,2.875,5.81v6.724c.001,1.873-1.289,2.278-2.874,.911l-2.43-2.096c-1.566-1.35-2.829-3.939-2.829-5.789Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M18.761,770.211h0c-.82-.723-1.484-2.078-1.484-3.029l-.008-35.312c0-.95,.663-1.173,1.483-.499h0c.822,.676,1.49,1.999,1.49,2.953l.009,35.472c0,.955-.668,1.14-1.49,.415Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.561,750.594v-6.766c-.002-1.884,1.31-2.307,2.935-.939l2.523,2.124c1.646,1.385,2.986,4.06,2.987,5.969l.002,6.853c0,1.909-1.339,2.3-2.985,.881l-2.523-2.176c-1.625-1.402-2.938-4.061-2.938-5.945Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M31.62,781.545h0c-.852-.751-1.542-2.144-1.542-3.113l-.013-35.999c0-.968,.688-1.186,1.54-.484h0c.854,.703,1.548,2.062,1.549,3.035l.015,36.165c0,.973-.694,1.15-1.548,.397Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.254,761.475l-.002-6.897c0-1.92,1.361-2.33,3.05-.909l2.622,2.207c1.71,1.44,3.103,4.189,3.104,6.135l.003,6.988c0,1.946-1.391,2.322-3.102,.847l-2.622-2.261c-1.689-1.456-3.052-4.189-3.053-6.11Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M44.987,793.327h0c-.886-.781-1.604-2.214-1.604-3.202l-.02-36.713c0-.987,.716-1.198,1.601-.469h0c.888,.731,1.61,2.129,1.611,3.121l.021,36.885c0,.993-.721,1.161-1.61,.378Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.444,772.784l-.004-7.033c0-1.958,1.415-2.353,3.17-.875l2.726,2.295c1.778,1.497,3.228,4.325,3.229,6.31l.004,7.127c.001,1.985-1.446,2.345-3.225,.811l-2.727-2.352c-1.756-1.514-3.173-4.324-3.174-6.283Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M58.891,805.582h0c-.922-.813-1.669-2.288-1.67-3.296l-.027-37.455c0-1.007,.744-1.21,1.666-.451h0c.924,.761,1.676,2.199,1.677,3.211l.028,37.635c0,1.013-.75,1.172-1.675,.357Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.162,784.544l-.005-7.175c-.001-1.998,1.471-2.376,3.298-.839l2.837,2.388c1.851,1.558,3.36,4.469,3.362,6.494l.006,7.273c.002,2.025-1.505,2.367-3.356,.77l-2.837-2.447c-1.827-1.576-3.302-4.467-3.304-6.465Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M73.368,818.342h0c-.961-.847-1.738-2.366-1.739-3.394l-.034-38.228c0-1.028,.775-1.222,1.735-.432h0c.963,.792,1.746,2.273,1.747,3.306l.036,38.415c0,1.034-.781,1.182-1.744,.333Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.44,796.785l-.006-7.322c-.002-2.039,1.531-2.399,3.433-.798l2.955,2.487c1.928,1.623,3.5,4.621,3.502,6.689l.007,7.424c.002,2.068-1.567,2.389-3.496,.726l-2.955-2.549c-1.903-1.641-3.439-4.618-3.441-6.657Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M88.451,831.637h0c-1.001-.883-1.812-2.448-1.813-3.499l-.042-39.034c-.001-1.05,.807-1.234,1.808-.411h0c1.003,.826,1.82,2.352,1.821,3.407l.044,39.229c.001,1.056-.814,1.193-1.818,.308Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.312,809.535l-.008-7.476c-.002-2.082,1.595-2.423,3.578-.754l3.08,2.593c2.01,1.692,3.65,4.782,3.652,6.894l.009,7.582c.002,2.112-1.633,2.411-3.644,.677l-3.08-2.657c-1.983-1.71-3.584-4.778-3.586-6.86Z",
    fill: "#7f5640"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M104.181,845.501h0c-1.045-.921-1.89-2.535-1.892-3.609l-.051-39.875c-.001-1.072,.842-1.246,1.886-.387h0c1.047,.862,1.899,2.435,1.9,3.513l.053,40.078c.001,1.079-.849,1.203-1.896,.279Z",
    fill: "#7f5640"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.817,822.828l-.009-7.636c-.003-2.126,1.663-2.445,3.731-.704l3.213,2.705c2.097,1.766,3.809,4.953,3.812,7.11l.011,7.747c.003,2.158-1.704,2.433-3.802,.623l-3.214-2.772c-2.068-1.784-3.739-4.947-3.742-7.074Z",
    fill: "#7f5640"
  })))))), /*#__PURE__*/React.createElement("path", {
    d: "M607.11,0c-3.8,1.43-9.05,2.04-13.99,2.05-6.31,.01-12.42-.78-18.67-1.11-16.38-.89-32.9,1.38-49.24,2.85-25.59,2.31-51.65,2.72-77.61,3.13-19.91,.3-39.89,.61-59.73,.17-19.63-.43-39.1-1.6-58.73-1.97-56.18-1.07-113.73,4.33-168.39-1.14-3.59-.35-7.18-.76-10.75-1.18l-29.05,.44V307.93c17.37-3.34,35.1-4.78,52.78-4.27,17,.5,33.88,2.79,50.8,4.61,1.25,.14,2.5,.27,3.75,.4,50.34,5.2,101.26,4.81,151.53-1.16,4.39-.52,8.77-1.09,13.14-1.75,7.23-1.1,14.41-2.48,21.46-4.41,8-2.18,15.81-5.06,23.86-7.05,17.95-4.43,36.66-4.34,55.15-4.23,24.2,.16,48.4,.31,72.6,.46,14.19,.09,28.7,.25,42.49,3.2L607.11,0Z",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "translate(153.031 227.442)",
    fontFamily: "Lato-Black, Lato",
    fontSize: 31,
    letterSpacing: ".14em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "A3"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 42
  }, "PRINTER")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgA3Printer);
export default __webpack_public_path__ + "static/media/a3-printer.4819ac7026d7e8f1536311c70ada983b.svg";
export { ForwardRef as ReactComponent };